// extracted by mini-css-extract-plugin
export var formContainer = "_c4-0";
export var message = "_c4-1";